'use strict';

angular.module(ApplicationConfiguration.applicationModuleName).service('permissionService', ['settings', '$state', '$filter', 'MessageService', function (settings, $state, $filter, MessageService) {
	var self = {};

	self.isAdmin = function () {
		return (settings.staffId != null && settings.staffId != 0);
	}

	self.isAuthorized = function (task) {
		if (!task) {
			return self.isAdmin();
		}

		return (
			self.isAdmin()
			|| (settings.permissions && settings.permissions.indexOf(task) != -1)
		);
	}

	self.isAdminAccessAuthorized = function () {
		if (self.isAuthorized('AdminAccess') == false) {
			var $translate = $filter('translate');

			MessageService.alertInfo($translate('global.accessDeniedMessage'), $translate('global.accessDenied'), function () {
				$state.go('main.dashboard');
			})
			return false;
		}
		return true;
	}


	return self;
}]);